import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "ariaLabel", "ariaLabelledby", "ariaDescribedby", "ariaDescription", "dataTestId", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef } from 'react';
import { TextRoot } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Config-layer wrapper for `Text`. Exposes the element, variant, and truncation
 * props with a curated accessibility attribute set, instead of the full HTMLElement attribute surface.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link TextRoot | Text}
 */
export const Text = /*#__PURE__*/forwardRef((t0, ref) => {
  var _id, _ariaLabel, _ariaLabelledby, _ariaDescribedby, _ariaDescription, _dataTestId;
  const $ = _c(19);
  let ariaDescribedby;
  let ariaDescription;
  let ariaLabel;
  let ariaLabelledby;
  let children;
  let dataTestId;
  let id;
  let restProps;
  if ($[0] !== t0) {
    const {
        children: t1,
        id: t2,
        ariaLabel: t3,
        ariaLabelledby: t4,
        ariaDescribedby: t5,
        ariaDescription: t6,
        dataTestId: t7
      } = t0,
      t8 = _objectWithoutPropertiesLoose(t0, _excluded);
    children = t1;
    id = t2;
    ariaLabel = t3;
    ariaLabelledby = t4;
    ariaDescribedby = t5;
    ariaDescription = t6;
    dataTestId = t7;
    restProps = t8;
    $[0] = t0;
    $[1] = ariaDescribedby;
    $[2] = ariaDescription;
    $[3] = ariaLabel;
    $[4] = ariaLabelledby;
    $[5] = children;
    $[6] = dataTestId;
    $[7] = id;
    $[8] = restProps;
  } else {
    ariaDescribedby = $[1];
    ariaDescription = $[2];
    ariaLabel = $[3];
    ariaLabelledby = $[4];
    children = $[5];
    dataTestId = $[6];
    id = $[7];
    restProps = $[8];
  }
  const t1 = (_id = id) === null || _id === void 0 ? void 0 : _id.root;
  const t2 = (_ariaLabel = ariaLabel) === null || _ariaLabel === void 0 ? void 0 : _ariaLabel.root;
  const t3 = (_ariaLabelledby = ariaLabelledby) === null || _ariaLabelledby === void 0 ? void 0 : _ariaLabelledby.root;
  const t4 = (_ariaDescribedby = ariaDescribedby) === null || _ariaDescribedby === void 0 ? void 0 : _ariaDescribedby.root;
  const t5 = (_ariaDescription = ariaDescription) === null || _ariaDescription === void 0 ? void 0 : _ariaDescription.root;
  const t6 = (_dataTestId = dataTestId) === null || _dataTestId === void 0 ? void 0 : _dataTestId.root;
  let t7;
  if ($[9] !== children || $[10] !== ref || $[11] !== restProps || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = /*#__PURE__*/_jsx(TextRoot, Object.assign({}, restProps, {
      ref: ref,
      id: t1,
      "aria-label": t2,
      "aria-labelledby": t3,
      "aria-describedby": t4,
      "aria-description": t5,
      "data-test-id": t6,
      children: children
    }));
    $[9] = children;
    $[10] = ref;
    $[11] = restProps;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
});
Text.displayName = 'Text';